exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "html{height:100%}body{height:100%}#root{height:100%}\n", "",{"version":3,"sources":["/home/ubuntu/workspace/Locus_fr-tracking-tms-fe_master/src/app.css"],"names":[],"mappings":"AAAA,KACE,WAAY,CACb,KAGC,WAAY,CACb,MAGC,WAAY","file":"app.css","sourcesContent":["html {\n  height: 100%;\n}\n\nbody {\n  height: 100%;\n}\n\n#root {\n  height: 100%;\n}\n"]}]);
// Exports
exports.locals = {
	"root": "root"
};